var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckSquare, faSquare } from "@fortawesome/pro-solid-svg-icons";
/** <b>Composant d'affichage en mode édition d'un champ de type bool</b>*/
export default function BoolFieldEdit(_a) {
    var fieldName = _a.fieldName, record = _a.record, onUpdate = _a.onUpdate, fieldMetadata = _a.fieldMetadata;
    var convertToZeroOne = function (value) {
        if (value === true || value === "1" || value === 1)
            return 1;
        if (value === false || value === "0" || value === 0)
            return 0;
        return value;
    };
    var defaultValue = useMemo(function () {
        if (!record[fieldName]) {
            return fieldMetadata.default && convertToZeroOne(fieldMetadata.default);
        }
        else {
            return record[fieldName || ""];
        }
    }, [fieldName, record]);
    var _b = useState(), value = _b[0], setValue = _b[1];
    useEffect(function () {
        defaultValue && setValue(Boolean(Number(defaultValue)));
    }, [defaultValue]);
    var onCheck = function () {
        var _a;
        setValue(!value);
        var newValue = !value;
        onUpdate && onUpdate((_a = {}, _a[fieldName] = newValue ? "1" : "0", _a));
    };
    return (_jsx("span", __assign({ onClick: onCheck }, { children: _jsx(FontAwesomeIcon, { icon: value ? faCheckSquare : faSquare, className: "flex items-center cursor-pointer ".concat(value
                ? "text-[rgb(var(--color-blue-500))]"
                : "border border-black text-white text-xs") }) })));
}
